import { render, staticRenderFns } from "./CCheckbox.vue?vue&type=template&id=4f0eab1c&scoped=true&"
import script from "./CCheckbox.vue?vue&type=script&lang=js&"
export * from "./CCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./CCheckbox.vue?vue&type=style&index=0&id=4f0eab1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0eab1c",
  null
  
)

export default component.exports